import styled from 'styled-components';

export const Wrapper = styled.div`
  height: calc(100% - 100px);
  padding: 15px 30px 100px;
  background-color: var(--athens-gray);
`;
